/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Button, FlexContainer, H2, Modal, Text, Stack, Container } from "@carrotfertility/carotene"
import useEmailVerification from "./useEmailVerification"
import PersonalEmailActionTaken from "./PersonalEmailActionTaken"
import { FormattedMessage, useIntl } from "react-intl"
import EmployeeOnlyModalContainer from "../employee-only-containers/EmployeeOnlyModalContainer"

type RemoveEmailModalProps = {
  open: boolean
  onClose: () => void
  showEmailRemoved: boolean
  setShowEmailRemoved: (boolean) => void
  removeDisabled: boolean
  setRemoveDisabled: (boolean) => void
}

export default function RemoveEmailModal({
  open,
  onClose,
  showEmailRemoved,
  setShowEmailRemoved,
  removeDisabled,
  setRemoveDisabled
}: RemoveEmailModalProps): JSX.Element {
  const { removePersonalEmail } = useEmailVerification()
  const intl = useIntl()

  async function onRemove(event) {
    event.preventDefault()
    setRemoveDisabled(true)
    await removePersonalEmail()
    setShowEmailRemoved(true)
  }

  return (
    <EmployeeOnlyModalContainer onClose={onClose} open={open}>
      <Modal open={open} onClose={onClose} showClose={false}>
        {showEmailRemoved ? (
          <PersonalEmailActionTaken
            header={intl.formatMessage({ defaultMessage: "Email address removed" })}
            body={intl.formatMessage({ defaultMessage: "This email address was successfully removed." })}
            image={"illo-envelope-minus"}
            onClose={onClose}
          />
        ) : (
          <>
            <FlexContainer padding={"huge"} direction={"column"}>
              <Container stack={"huge"}>
                <H2 color={"black80"} stack={"tiny"}>
                  <FormattedMessage defaultMessage="Are you sure you want to remove this email address?" />
                </H2>
                <Text color={"black60"}>
                  <FormattedMessage defaultMessage="If you remove this address, our messages will go to the address you use for signing in to Carrot." />
                </Text>
              </Container>
              <FlexContainer justifyContent="flex-end">
                <Stack spacing={"small"} direction={"row"}>
                  <Button variant={"secondary"} onClick={onClose}>
                    <FormattedMessage defaultMessage="Cancel" />
                  </Button>
                  <Button disabled={removeDisabled} onClick={(event) => onRemove(event)}>
                    <FormattedMessage defaultMessage="Remove" />
                  </Button>
                </Stack>
              </FlexContainer>
            </FlexContainer>
          </>
        )}
      </Modal>
    </EmployeeOnlyModalContainer>
  )
}
